// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"bd7885b6","283":"d72e79d8","816":"db8aa09a","873":"fe48ef04","885":"a4c2207b"}[chunkId] + ".chunk.js";
};